<template>
  <div style="margin-left: 3rem">
    <h2>创建用户：</h2>
    <a-form layout="inline">
      <a-form-item>
        <a-input placeholder="用户名" v-model="newUserForm.name" />
      </a-form-item>
      <a-form-item>
        <a-input placeholder="email" v-model="newUserForm.email" />
      </a-form-item>
      <a-form-item>
        <a-input placeholder="密码" v-model="newUserForm.pwd" />
      </a-form-item>
      <a-form-item>
        <a-button @click="newUser">创建新用户</a-button>
      </a-form-item>
    </a-form>
    <h2>删除算法：</h2>
    <a-input placeholder="aid" v-model="deleteAlgId" style="width: 10rem" />
    <a-popconfirm
      title="是否确认？"
      ok-text="是"
      cancel-text="否"
      @confirm="deleteAlg"
    >
      <a-button>删除该算法</a-button>
    </a-popconfirm>

    <h2>新增算法：</h2>
    <a-input
      placeholder="package_name"
      v-model="newAlgData.packageName"
      style="width: 10rem"
    />
    <a-input
      placeholder="class_name"
      v-model="newAlgData.className"
      style="width: 10rem"
    />
    <a-popconfirm
      title="是否确认？"
      ok-text="是"
      cancel-text="否"
      @confirm="newAlg"
    >
      <a-button>新增算法</a-button>
    </a-popconfirm>

    <h2>同步：</h2>
    <a-popconfirm
      title="是否确认？"
      ok-text="是"
      cancel-text="否"
      @confirm="syncAlg"
    >
      <a-button>同步算法</a-button>
    </a-popconfirm>
    <a-popconfirm
      title="是否确认？"
      ok-text="是"
      cancel-text="否"
      @confirm="syncDoc"
    >
      <a-button>同步帮助文档</a-button>
    </a-popconfirm>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newUserForm: {
        name: '',
        email: '',
        pwd: ''
      },
      newAlgData: {
        packageName: '',
        className: ''
      },
      deleteAlgId: ''
    }
  },
  methods: {
    newUser() {
      this.$http.post('/admin/create_user', this.newUserForm)
    },
    deleteAlg() {
      this.$http.delete(`/admin/algorithm/${this.deleteAlgId}`)
    },
    newAlg() {
      this.$http.post(
        '/admin/algorithm/add',
        { package_name: this.newAlgData.packageName, class_name: this.newAlgData.className })
    },
    syncDoc() {
      this.$http.put('/admin/help_doc/sync')
    },
    syncAlg() {
      this.$http.put('/admin/algorithm/sync')
    }
  }
}
</script>

<style>
</style>
